import { render, staticRenderFns } from "./PortalMenu.vue?vue&type=template&id=029a5356&"
import script from "./PortalMenu.vue?vue&type=script&lang=js&"
export * from "./PortalMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports